<div id="openExtendsGalleryTourism" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Seleccionar imágenes para el paquete</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>
      <div class="modal-body p-t-0">
        <div class="row">
          <div class="col-lg-12">
            <ul class="nav nav-pills nav-justified">
              <li class="nav-item" *ngFor="let tab of tabs; let i = index">
                <a class="nav-link pointer" [class.active]="i === activeTab" (click)="changeTab(i)">{{ tab }}</a>
              </li>
            </ul>
            <div class="tab-content p-10">
              <ng-container *ngIf="activeTab == 0">
                <div class="col-lg-12">
                  <div class="row">
                    <!-- <div class="form-group col-lg-6">
                      <label>Seleccionar Tour<span class="required"></span></label>
                      <ng-select [items]="items" bindLabel="name" [(ngModel)]="selectedItem">
                      </ng-select>
                    </div> -->
                    <div class="form-group col-lg-6">
                      <label>Seleccionar Tour<span class="required"></span></label>
                      <ng-select [items]="tours" bindLabel="description" [(ngModel)]="selectedTour">
                      </ng-select>
                    </div>
                    <div class="col-lg-3 p-t-30 p-l-0 p-r-0">
                      <button class="btn btn-info" (click)="getImgTour()">Cargar imágenes</button>
                    </div>
                    <div class="col-lg-12">
                      <ng-container *ngIf="img_tours.length == 0">
                        <span>No se encontraron imágenes.</span>
                      </ng-container>
                      <ng-container *ngIf="img_tours.length > 0">
                        <div class="row">
                          <div class="col-lg-3 m-b-15 p-l-10 p-r-10" *ngFor="let img of img_tours; let index_ = index">
                            <span style="position: absolute;
                            top: 0px;
                            left: 10px;
                            right: 10px;
                            background: #fff;
                            bottom: 35px;
                            opacity: .5;" *ngIf="img.checked"></span>
                            <img style="width: 100%; height: 140px" src="tenants/{{img.url_image}}" alt="Image Preview">
                            <label class="pointer m-t-5">
                              <input style="width:17px; height: 17px;" type="checkbox" [(ngModel)]="img.checked"
                                (change)="changeChecked()"> Seleccionar
                            </label>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="activeTab == 1">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label>Seleccionar Hotel<span class="required"></span></label>
                      <ng-select [items]="hotels" bindLabel="tradename" [(ngModel)]="selectedHotel">
                      </ng-select>
                    </div>
                    <div class="col-lg-3 p-t-30 p-l-0 p-r-0">
                      <button class="btn btn-info" (click)="getImgHotel()">Cargar imágenes</button>
                    </div>
                    <div class="col-lg-12">
                      <ng-container *ngIf="img_hotels.length == 0">
                        <span>No se encontraron imágenes.</span>
                      </ng-container>
                      <ng-container *ngIf="img_hotels.length > 0">
                        <div class="row">
                          <div class="col-lg-3 m-b-15 p-l-10 p-r-10" *ngFor="let img of img_hotels; let index_ = index">
                            <span style="position: absolute;
                            top: 0px;
                            left: 10px;
                            right: 10px;
                            background: #fff;
                            bottom: 35px;
                            opacity: .5;" *ngIf="img.checked"></span>
                            <img style="width: 100%; height: 140px" src="tenants/{{img.url_image}}" alt="Image Preview">
                            <label class="pointer m-t-5">
                              <input style="width:17px; height: 17px;" type="checkbox" [(ngModel)]="img.checked"
                                (change)="changeCheckedHotel()"> Seleccionar
                            </label>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-lg-12 m-t-15 text-right">
            <button class="btn btn-dark" (click)="addSelecteds()">Agregar Seleccionados ({{count_selecteds}})</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
